import { FIELD_DEVELOPMENTAL_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import Toggle from "PFComponents/toggle/toggle";
import { Typography } from "PFComponents/typography";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import css from "./activity_skills_settings.module.scss";

export const ActivitySkillsSettings = () => {
  const { t } = useTranslation("activities", { keyPrefix: "form.skillsSettings" });
  const { control } = useFormContext();
  const isDevelopmental = useWatch({ name: FIELD_DEVELOPMENTAL_KEY });

  return (
    <Inline alignItems="center" spread className={css.settingsRow}>
      <Inline>
        <Controller
          name={FIELD_DEVELOPMENTAL_KEY}
          control={control}
          render={({ field }) => (
            <Toggle
              description={t("developmentalSkillsToggleLabel")}
              onChange={field.onChange}
              checked={field.value}
              compact
            />
          )}
        />
      </Inline>
      {isDevelopmental && (
        <Inline alignItems="center">
          <Icon name="info" />
          <Typography withMargin variant="labelRegular">
            {t("developmentalSkillsInfo")}
          </Typography>
        </Inline>
      )}
    </Inline>
  );
};
